import { connect } from 'react-redux'

import { fetchArea } from '../../actions/areas'
import { fetchWorkTrackersForArea } from '../../actions/work-trackers'

import WorkTrackerAreaDetails from '../../components/areas/work-tracker-area-details'

function mapStateToProps (state, ownProps) {
  const area = state.areas[ownProps.params.areaId]

  if (!area) return {}

  const latestHistory = state.areaHistories[area.latestHistory]
  const technician = state.users[(latestHistory || {}).technician]

  return {
    area,
    latestHistory,
    technician
  }
}

function mapDispatchToProps (dispatch, ownProps) {
  const id = ownProps.params.areaId

  dispatch(fetchArea(id))
    .then(() => dispatch(fetchWorkTrackersForArea(id)))

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkTrackerAreaDetails)



// WEBPACK FOOTER //
// ./src/containers/areas/work-tracker-area-details-container.js